<div class="start-date">
  <input
    nbInput
    fullWidth
    [placeholder]="placeholder()"
    [nbDatepicker]="startDatePicker"
    [(ngModel)]="startDate"
    [disabled]="isDisabled"
    readonly />
  <nb-date-timepicker
    #startDatePicker
    [min]="min()"
    [max]="max()"
    format="dd.LL.yyyy HH:mm"></nb-date-timepicker>
</div>

<div>&ndash;</div>

<div class="end-date">
  <input
    nbInput
    fullWidth
    [placeholder]="placeholder()"
    [nbDatepicker]="endDatePicker"
    [(ngModel)]="endDate"
    [disabled]="isDisabled"
    readonly
  />
  <nb-date-timepicker
    #endDatePicker
    [min]="min()"
    [max]="max()"
    format="dd.LL.yyyy HH:mm"></nb-date-timepicker>
</div>
